import Vue from 'vue';
import moment from 'moment'

Vue.filter('FormatDate', function(value, format) {
  if (value) {
    return moment(String(value)).format(format)
  }
});